import { CalendarioDia, StatusDia } from '../tipos/ajudaCusto'
import { DIAS_SEMANA, parseDataLocal } from '../utils'

interface CalendarioRegistroProps {
  dias: CalendarioDia[]
  onClickDia: (dia: CalendarioDia) => void
}

function classesDoStatus(status: StatusDia): string {
  switch (status) {
    case StatusDia.ComRegistro:
      return 'bg-green-500 text-white hover:bg-green-600'
    case StatusDia.Hoje:
      return 'bg-brand-500 text-white ring-2 ring-brand-700 hover:bg-brand-600 cursor-pointer'
    case StatusDia.SemRegistroSolicitavel:
      return 'bg-red-500 text-white hover:bg-red-600 cursor-pointer'
    case StatusDia.SemRegistroForaJanela:
      return 'bg-red-400 text-white opacity-70 cursor-not-allowed'
    case StatusDia.SolicitacaoPendente:
      return 'bg-yellow-400 text-gray-900 hover:bg-yellow-500'
    case StatusDia.Futuro:
    default:
      return 'bg-gray-100 text-gray-400 cursor-not-allowed'
  }
}

export function CalendarioRegistro({ dias, onClickDia }: CalendarioRegistroProps) {
  if (dias.length === 0) return null

  const primeiroDiaSemana = parseDataLocal(dias[0].data).getDay()
  const blanks = Array.from({ length: primeiroDiaSemana })

  return (
    <div>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {DIAS_SEMANA.map((d) => (
          <div key={d} className="text-center text-xs font-semibold text-gray-500 uppercase py-1">
            {d}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {blanks.map((_, i) => (
          <div key={`b${i}`} />
        ))}
        {dias.map((dia) => {
          const numero = parseDataLocal(dia.data).getDate()
          const clicavel = dia.podeRegistrarHoje || dia.podeSolicitarAjuste
          return (
            <button
              key={dia.data}
              type="button"
              disabled={!clicavel}
              onClick={() => onClickDia(dia)}
              title={dia.registroPago ? 'Pago' : dia.justificativaSolicitacao || undefined}
              className={`relative aspect-square rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${classesDoStatus(dia.status)}`}
            >
              {numero}
              {dia.registroPago && (
                <span className="absolute bottom-1 right-1 h-1.5 w-1.5 rounded-full bg-white" />
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
